module.exports = __webpack_public_path__ + "img/index-s-3.e6d45c84.png";